import {
  CLIENT_QUESTIONNAIRE_COMPLETED,
  CLIENT_QUESTIONNAIRE_STARTED,
  HMLR_TRACKING_EVENT_STARTED,
  HMLR_TRACKING_EVENT_COMPLETED,
} from '@/values/trackingEvents';

export default {
  name: 'Client Questionnaire',
  path: 'SaleClientQuestionnaire',
  icon: 'CQ',
  event_slug: 'client_questionnaire',
  trackingEvents: {
    startedEvent: CLIENT_QUESTIONNAIRE_STARTED,
    completedEvent: CLIENT_QUESTIONNAIRE_COMPLETED,
    pendingEvent: HMLR_TRACKING_EVENT_STARTED,
    furtherInputNeededEvent: HMLR_TRACKING_EVENT_COMPLETED,
  },
  visible: true,
  active: false,
  status: false,
  whatsNextInfo: false,
};
